import React, { useState, useEffect, useMemo } from 'react'
import { Dialog, Button, TextField, Grid } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

const inputLabelProps = {
  classes: {
    shrink: 'text-black font-bold',
    focused: 'text-primary',
  },
}

const LabelsEditorDialog = ({ open, onClose, labelOrders, getLabels, updateLabels }) => {
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(true)
  const [errored, setErrored] = useState(false)
  const [labels, setLabels] = useState({})
  const labelsNames = useMemo(() => Object.keys(labels).sort((a, b) => labelOrders?.indexOf(a) - labelOrders?.indexOf(b)), [labels])

  const loadData = async () => {
    setLoading(true)
    setErrored(false)
    try {
      const labels = await getLabels()
      setLabels(labels || {})
    } catch (error) {
      setErrored(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSaveClick = async () => {
    if (saving) return
    setSaving(true)
    try {
      await updateLabels(labels)
      onClose()
    } catch (error) {
    } finally {
      setSaving(false)
    }
  }

  return (
    <Dialog maxWidth="sm" open={open} onClose={onClose}>
      <h4 className="capitalize m-0 mb-4">Update labels</h4>
      {loading ? (
        <CircularProgress />
      ) : errored ? (
        <span>Failed to load data</span>
      ) : (
        labelsNames.map((label) => {
          return (
            <Grid ket={label} container mb={2} >
              <Grid item sm={12}>
                <TextField
                  label={label}
                  value={labels[label]}
                  onChange={(event) => {
                    labels[label] = event.target.value
                    setLabels({ ...labels })
                  }}
                  InputLabelProps={inputLabelProps}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
          )
        })
      )}
      <div className="flex justify-start pt-2 m--2">
        <Button
          className="m-2 rounded hover-bg-primary px-6"
          variant="outlined"
          color="primary"
          disabled={saving}
          onClick={errored ? loadData : onSaveClick}
          startIcon={saving ? <CircularProgress size={16} /> : null}
        >
          {errored ? 'Reload' : 'Save'}
        </Button>
        <Button
          className="m-2 rounded hover-bg-error px-6"
          variant="outlined"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Dialog>
  )
}

export default LabelsEditorDialog
